import * as React from 'react';
import { createContext, useContext } from 'react';

import { TProfileContextType } from './types.ts';

export const ProfileContext = createContext<TProfileContextType | null>(null);

export function useProfileContext(): TProfileContextType {
    const context = useContext(ProfileContext as React.Context<TProfileContextType | null>);
    if (!context) throw new Error('Provider is missing');

    return context;
}
